import { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { PuffLoader } from 'react-spinners';
import { fetchCardDetail } from '../../redux/thunk/fetchCardDetail';
import { normalizeListingDetail } from '../../utils/normalizeListingDetail';
import { extractListingFields, formatPriceTL } from '../../utils/extractListingFields';
import {
  formatListingDescription,
  isDisplayableDescription,
} from '../../utils/formatListingDescription';
import { clearCardDetail } from '../../redux/slice/cardDetailSlice';
import { scrollPageToTop } from '../../utils/scrollToTop';
import "./Property.css";
import { BiArrowBack, BiHeart } from 'react-icons/bi';
import {AiOutlineArrowRight} from "react-icons/ai"
import Whatsapp1 from '../Whatsapp1/Whatsapp1';
import Call1 from '../Call1/Call1';


const Property = () => {

  const [buyukResimIndex, setBuyukResimIndex] = useState(0);


  const { id } = useParams();
  const rawDetail = useSelector((state) => state.cardDetail);
  const cardDetail = useMemo(
    () => normalizeListingDetail(rawDetail),
    [rawDetail]
  );
  const fields = useMemo(
    () => extractListingFields(cardDetail),
    [cardDetail]
  );
  const dispatch = useDispatch();
  const [loadError, setLoadError] = useState(null);

  const kucukResimler = fields?.images?.length ? fields.images : [];
  const currentBigImage =
    kucukResimler[buyukResimIndex]?.originalImageUrl ||
    kucukResimler[0]?.originalImageUrl ||
    "";

  const handleImageError = (e) => {
    const current = e.currentTarget.src;
    if (!current || e.currentTarget.dataset.fallbackTried === "true") return;
    e.currentTarget.dataset.fallbackTried = "true";

    if (current.includes("/image-proxy")) {
      const match = current.match(/[?&]url=([^&]+)/);
      if (match) {
        try {
          const direct = decodeURIComponent(match[1]);
          if (direct && direct !== current) {
            e.currentTarget.src = direct;
          }
        } catch {
          // ignore
        }
      }
    }
  };

  const listingDescriptionText = useMemo(() => {
    if (!fields) return "";
    return formatListingDescription(fields.description);
  }, [fields]);

  const showListingDescription = useMemo(() => {
    if (!fields) return false;
    return isDisplayableDescription(fields.description, fields.title);
  }, [fields]);

  const formattedDate = useMemo(() => {
    if (!fields?.createdAt) return "";
    const turkishMonths = [
      "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
      "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık",
    ];
    const date = new Date(fields.createdAt);
    return `${date.getDate()} ${turkishMonths[date.getMonth()]} ${date.getFullYear()}`;
  }, [fields?.createdAt]);

  const hücreStili = {
    borderBottom: "1px dotted gray",
    padding: "2%",
  };

  const renderDetailRows = () => {
    if (!fields) return null;
    const rows = [
      ["İlan No", fields.id],
      ["İlan Tarihi", formattedDate],
      ["İlan Kategori", `${fields.tradeType} ${fields.category}`.trim()],
      ["Emlak Türü", fields.estateType],
      ["Konum", fields.locationLine],
      ["Oda Sayısı", fields.roomCount],
      ["Bulunduğu Kat", fields.floorCount],
      ["m²", fields.square],
      ["m² (Net)", fields.netSquare],
      ["m² (Brüt)", fields.grossSquare],
      ["Isıtma", fields.heating],
      ["Banyo", fields.bathCount],
      ["Bina Yaşı", fields.buildAge],
      ["Tapu", fields.deed],
      ["Krediye Uygunluk", fields.credit],
      ["Takas", fields.trade],
      ["Kat Karşılığı", fields.flatForConstruction],
      ["Eşya Durumu", fields.furniture],
      ["Kullanım Durumu", fields.usability],
      ...fields.extras.map((e) => [e.label, e.value]),
    ];
    return rows
      .filter(([, v]) => v != null && String(v).trim() !== "")
      .map(([label, value]) => (
        <tr key={label}>
          <td style={hücreStili}>
            <b>{label}</b>
          </td>
          <td style={hücreStili}>{value}</td>
        </tr>
      ));
  };

  useLayoutEffect(() => {
    scrollPageToTop();
  }, [id]);

  useEffect(() => {
    setLoadError(null);
    setBuyukResimIndex(0);
    dispatch(fetchCardDetail(id)).catch(() => {
      setLoadError("İlan detayı yüklenemedi. Lütfen ilanlar sayfasından tekrar deneyin.");
    });

    return () => {
      dispatch(clearCardDetail());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (
      cardDetail?.result?.id &&
      String(cardDetail.result.id) === String(id)
    ) {
      scrollPageToTop();
    }
  }, [id, cardDetail?.result?.id]);

  if (loadError) {
    return (
      <div className="wrapper flexCenter flex-col gap-4" style={{ height: "60vh" }}>
        <p className="text-center text-red-600 px-4">{loadError}</p>
        <a href="/adverts" className="btn btn-secondary">
          İlanlara dön
        </a>
      </div>
    );
  }

  if (!cardDetail?.result) {
    return (
      <div className="wrapper flexCenter" style={{ height: "60vh" }}>
        <PuffLoader
          height="80"
          width="80"
          radius={1}
          color="#c5955b"
          aria-label="puff-loading"
        />
      </div>
    );
  }


  

const ileriGit = () => {

  const sonSatirIndis = kucukResimler.length - 1;

  if(buyukResimIndex !== sonSatirIndis )  {
  setBuyukResimIndex((prevIndex) => (prevIndex + 1) % kucukResimler.length);
  }
  
  
  scrollX(140); // Sağa doğru 100 piksel kaydırma

};

const geriGit = () => {

  

  if(buyukResimIndex !== 0 )  {
    setBuyukResimIndex((prevIndex) =>
    prevIndex === 0 ? kucukResimler.length - 1 : prevIndex - 1
  );
  }
  

  scrollX(-140); // Sola doğru 100 piksel kaydırma


}

const ileriGitMobil = () => {

  const sonSatirIndis = kucukResimler.length - 1;

  if(buyukResimIndex !== sonSatirIndis )  {
  setBuyukResimIndex((prevIndex) => (prevIndex + 1) % kucukResimler.length);
  }
  
  
  scrollXMobil(140); // Sağa doğru 100 piksel kaydırma

};

const geriGitMobil = () => {

  

  if(buyukResimIndex !== 0 )  {
    setBuyukResimIndex((prevIndex) =>
    prevIndex === 0 ? kucukResimler.length - 1 : prevIndex - 1
  );
  }
  

  scrollXMobil(-140); // Sola doğru 100 piksel kaydırma


}





  const scrollX = (amount) => {
    const container = document.getElementById('resimikaydir');
    if (container) {
      container.scrollLeft  += amount;
    
    }
  };

  const scrollXMobil = (amount) => {
    const container = document.getElementById('resimikaydirMobil');
    if (container) {
      container.scrollLeft  += amount;
    
    }
  };
 
 
  

  return (
    <div className="div1" key={JSON.stringify("")}>



    <div className='en büyük div sm:py-10 sm:px-10 focus:outline-none'>
      <div className='w-full '>
        <div className='flex justify-between align-center gap-4'>
          
          
          <h1 className='text-xl font-bold mr-5 p-4  baslık'>{ fields?.title }
      
      </h1>
     
    </div>
      
    <div className="w-full h-0.5 bg-slate-200 "></div>
    <div className='px-4 py-2 flex items-center justify-between text-primary gap-4 '>
       <div className="flex items-center gap-2">
         <div className="icon-box !w-7 !h-7  bg-primary/20 hover:bg-primary/40 text-primary ">
           <BiHeart />
         </div>
         <p >Favorilerime Ekle</p>
       </div>
     </div>
    </div>



  <div className='hidden sm:flex col alt-div justify-center p-[1rem] gap-2  item-center  ' >
  <div className="lg:flex">

  <div className='resim-slider lg:w-3/5 w-full m-[1rem] h-auto'>

          {/* Büyük resmi göstermek için bir <img> elementi */}
          <div className='buyuk-resim h-[30rem] w-full'>
            <img
              className='object-contain bg-dark'
              alt="İlan fotoğrafı"
              src={currentBigImage}
              onError={handleImageError}
              style={{ width: '100%', height: '100%' }}
            /> 
           
            {/* Sağa ve sola gitme düğmeleri */}
            <button type="button" className="property-nav-btn solaGit" onClick={geriGit}>
              <BiArrowBack/>
            </button>
            <button type="button" className="property-nav-btn sagaGit" onClick={ileriGit}>
              <AiOutlineArrowRight/>
            </button>
          </div>
    
          {/* Küçük resimleri göstermek için bir liste */}
          <div id="resimikaydir" className="overflow-x-auto whitespace-nowrap">
            <div className="inline-block pr-4">
              {/* Boş bir blok ekleyerek galerinin başlangıcını ayarlıyoruz */}
            </div>
            <div className="inline-block">
              {kucukResimler?.map((kucukResimURL, index) => (
                <img
                  alt={`İlan fotoğrafı ${index + 1}`}
                  key={index}
                  src={kucukResimURL.originalImageUrl}
                  onError={handleImageError}
                  onClick={() => setBuyukResimIndex(index)}
                  className={`object-fill h-[100px] w-[130px] lg:w-[130px] m-[5px] inline-block cursor-pointer ${
                    index === buyukResimIndex
                      ? 'border-2 border-solid border-orange-500' 
                      : ''
                  }`}
                />
              ))}
            </div>
           <div className="inline-block pl-4">
             {/* Boş bir blok ekleyerek galerinin sonunu ayarlıyoruz */}
           </div>
         </div>
          
    
        </div>
        <Call1 />
        <Whatsapp1 />
    <div className='lg:pl-20  h-auto '>
     

     <div className="justify-center item-center">
      <div className=' w-full  text-center'>
     
      <h1 className="text-xl text-center sm:text-left"><b className="text-primary"> {formatPriceTL(fields?.priceNum)} TL</b></h1>
         <h1 className="text-center sm:text-left"><b className="text-secondary dark:text-slate-200">{ fields?.locationLine }</b></h1>
      </div>
       
        <table className="tabloStili w-full max-w-full">
             <tbody>{renderDetailRows()}</tbody>
           </table>

     </div>
      
    </div>
</div>

</div>

<div className='lg:hidden md:hidden block flex col alt-div justify-center p-[1rem] gap-2  item-center  ' >


<div className='resim-slider lg:w-3/5 w-full m-[1rem] h-auto'>

        {/* Büyük resmi göstermek için bir <img> elementi */}
        <div className='buyuk-resim h-[30rem] w-full'>
          <img
            className='object-contain bg-dark'
            alt="İlan fotoğrafı"
            src={currentBigImage}
            onError={handleImageError}
            style={{ width: '100%', height: '100%' }}
          /> 
         
          {/* Sağa ve sola gitme düğmeleri */}
          <button type="button" className="property-nav-btn solaGit" onClick={geriGitMobil}>
            <BiArrowBack/>
          </button>
          <button type="button" className="property-nav-btn sagaGit" onClick={ileriGitMobil}>
            <AiOutlineArrowRight/>
          </button>
        </div>
  
        {/* Küçük resimleri göstermek için bir liste */}
        <div id="resimikaydirMobil" className="overflow-x-auto whitespace-nowrap">
          <div className="inline-block pr-4">
            {/* Boş bir blok ekleyerek galerinin başlangıcını ayarlıyoruz */}
          </div>
          <div className="inline-block">
            {kucukResimler?.map((kucukResimURL, index) => (
              <img
                alt={`İlan fotoğrafı ${index + 1}`}
                key={index}
                src={kucukResimURL.originalImageUrl}
                onError={handleImageError}
                onClick={() => setBuyukResimIndex(index)}
                className={`object-fill h-[100px] w-[130px] lg:w-[130px] m-[5px] inline-block cursor-pointer ${
                  index === buyukResimIndex
                    ? 'border-2 border-solid border-orange-500' 
                    : ''
                }`}
              />
            ))}
          </div>
         <div className="inline-block pl-4">
           {/* Boş bir blok ekleyerek galerinin sonunu ayarlıyoruz */}
         </div>
       </div>
        
  
      </div>

  <div className='lg:pl-20  h-auto '>
   

   <div className="justify-center item-center">
    <div className=' w-full  text-center'>
   
    <h1 className="text-xl text-center sm:text-left"><b className="text-primary"> {formatPriceTL(fields?.priceNum)} TL</b></h1>
       <h1 className="text-center sm:text-left"><b className="text-secondary dark:text-slate-200">{ fields?.locationLine }</b></h1>
    </div>
     
      <table className="tabloStili w-full max-w-full">
           <tbody>{renderDetailRows()}</tbody>
         </table>

   </div>
    
  </div>


</div>


    



    {showListingDescription ? (
      <div className="açıklama px-4 sm:px-8 mx-auto max-w-4xl mb-12">
        <h2 className="text-xl sm:text-2xl underline font-bold text-center py-8">
          İlan Açıklaması
        </h2>
        <p className="property-description text-left text-base leading-relaxed break-words whitespace-pre-wrap">
          {listingDescriptionText}
        </p>
      </div>
    ) : null}
    </div>

    </div>
      
      
      )
};

export default Property;
